var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.438,35.521H49.522l-5.348-5.348c-0.375-0.375-0.884-0.586-1.414-0.586H24.562c-1.104,0-2,0.896-2,2v5.934v26.891 c0,1.104,0.896,2,2,2h46.875c1.104,0,2-0.896,2-2V37.521C73.438,36.417,72.542,35.521,71.438,35.521z M26.562,33.588h15.37 l1.934,1.934H26.562V33.588z M69.438,62.412H26.562V39.521h22.132h20.743V62.412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.0bd7a621e521706c8f98244655b59e3b.svg";
export { ForwardRef as ReactComponent };